import { OnboardingLadderStepId } from '@/features/setup/types/onboarding-ladder-enums';

import { analytics } from '@/lib/analytics/analytics';
import {
  ANALYTICS_EVENT,
} from '@/lib/analytics/types/analytics-enums';

import * as Logger from '@/lib/monitoring/logger';
import type {
  OnboardingStepCompletedParams,
  OnboardingCompletedParams,
} from '../types/track-onboarding-types';

export function trackOnboardingStepCompleted(params: OnboardingStepCompletedParams): void {
  try {
    analytics.track(ANALYTICS_EVENT.ONBOARDING_STEP_COMPLETED, {
      stepId: params.stepId,
      stepLabel: params.stepLabel,
      stepKind: params.stepKind,
      stepIndex: params.stepIndex,
      totalSteps: params.totalSteps,
      completedSteps: params.completedSteps,
      completedAt: params.timestamp,
      ...(params.source && { source: params.source }),
      ...(params.integrationId && { integrationId: params.integrationId }),
    });
  } catch (err) {
    Logger.error('Failed to track onboarding step completed', err instanceof Error ? err : null, {
      errorMessage: err instanceof Error ? err.message : String(err),
      stepId: params.stepId,
    });
  }
}

export function trackOnboardingCompleted(params: OnboardingCompletedParams): void {
  try {
    analytics.track(ANALYTICS_EVENT.ONBOARDING_COMPLETED, {
      completedAt: params.timestamp,
      totalSteps: params.totalSteps,
      stepsCompleted: params.stepsCompleted,
    });
  } catch (err) {
    Logger.error('Failed to track onboarding completed', err instanceof Error ? err : null, {
      errorMessage: err instanceof Error ? err.message : String(err),
    });
  }
}

export function trackGetStartedViewed(params: {
  totalSteps: number;
  completedSteps: number;
}): void {
  try {
    analytics.track(ANALYTICS_EVENT.ONBOARDING_GET_STARTED_VIEWED, {
      totalSteps: params.totalSteps,
      completedSteps: params.completedSteps,
    });
  } catch (err) {
    Logger.error('Failed to track get started viewed', err instanceof Error ? err : null, {
      errorMessage: err instanceof Error ? err.message : String(err),
    });
  }
}

export function trackOnboardingStepViewed(params: {
  stepId: OnboardingLadderStepId;
  stepLabel: string;
  stepIndex: number;
  totalSteps: number;
}): void {
  try {
    analytics.track(ANALYTICS_EVENT.ONBOARDING_STEP_VIEWED, {
      stepId: params.stepId,
      stepLabel: params.stepLabel,
      stepIndex: params.stepIndex,
      totalSteps: params.totalSteps,
    });
  } catch (err) {
    Logger.error('Failed to track onboarding step viewed', err instanceof Error ? err : null, {
      errorMessage: err instanceof Error ? err.message : String(err),
      stepId: params.stepId,
    });
  }
}
